// ============================================================
// Tanımlar — yapılandırma sabitleri
//
// Buradakiler VERİ DEĞİL, tanım: gider kategorileri, kesinti
// oranları, olay türleri, bildirim kanalları, hatırlatma şablonları.
// Hem demo hem gerçek modda gerekliler.
//
// NEDEN AYRI DOSYA
// Bunlar eskiden demo kayıtlarla aynı dosyalardaydı (data/finans.js,
// data/health.js …). Alan modülleri tanımı içe aktarınca dosyanın
// TAMAMI ana pakete giriyordu — yanındaki demo kayıtlarla birlikte.
// Rollup'ın paket bölmesi dosya seviyesinde: bir modülü hem ana
// grafik hem demo parçası kullanıyorsa ortak parçaya, yani ana
// pakete düşüyor. Tanımları ayırmak, demo dosyalarını yalnızca
// data/demo.js'in içe aktardığı hâle getiriyor.
// ============================================================

export const GIDER_KATEGORI = {
  personel:  { label: "Personel", alt: ["Maaş", "Avans", "İkramiye", "İşveren payı", "Kıdem"] },
  bina:      { label: "Bina", alt: ["Kira", "Elektrik", "Su", "Isıtma/Soğutma", "İnternet", "Aidat"] },
  mutfak:    { label: "Mutfak", alt: ["Gıda alımı", "Mutfak sarf", "Gaz"] },
  servis:    { label: "Servis", alt: ["Yakıt", "Bakım", "Sigorta", "Muayene", "Şoför"] },
  egitim:    { label: "Eğitim", alt: ["Kırtasiye", "Oyuncak", "Kitap", "Etkinlik/Gezi", "Atölye malzemesi"] },
  temizlik:  { label: "Temizlik & Hijyen", alt: ["Temizlik malzemesi", "İlaçlama", "Çamaşır"] },
  guvenlik:  { label: "Sağlık & Güvenlik", alt: ["İlk yardım dolabı", "Yangın bakımı", "Güvenlik sistemi"] },
  idari:     { label: "İdari", alt: ["Muhasebe", "Hukuk", "Yazılım aboneliği", "Banka masrafı"] },
  resmi:     { label: "Vergi & Resmî", alt: ["Ruhsat", "Harç", "Sigorta poliçesi"] },
  yatirim:   { label: "Yatırım", alt: ["Mobilya", "Oyun grubu", "Tadilat", "Cihaz"] },
};

export const KESINTI_VARSAYILAN = {
  sosyalSigorta: 0.09,      // çalışan payı
  ihtiyatSandigi: 0.04,     // çalışan payı
  gelirVergisi: 0.10,       // basitleştirilmiş stopaj
  isverenSosyalSigorta: 0.115,
  isverenIhtiyatSandigi: 0.04,
};

export const OLAY_TURU = {
  dusme: { label: "Düşme", icon: "🩹" },
  isirik: { label: "Isırık", icon: "😬" },
  ates: { label: "Ateş", icon: "🌡️" },
  alerjik: { label: "Alerjik reaksiyon", icon: "⚠️" },
  carpma: { label: "Çarpma", icon: "💥" },
  diger: { label: "Diğer", icon: "📋" },
};

export const KANALLAR = {
  uygulama: { label: "Uygulama içi", icon: "🔔", ucret: 0, hazir: true },
  push:     { label: "Push",         icon: "📲", ucret: 0, hazir: false },
  sms:      { label: "SMS",          icon: "💬", ucret: 1.2, hazir: false },
  eposta:   { label: "E-posta",      icon: "✉️", ucret: 0, hazir: false },
  whatsapp: { label: "WhatsApp",     icon: "🟢", ucret: 0.4, hazir: false },
};

export const ONEM = {
  kritik: { label: "Kritik", renk: "coral", sira: 3 },
  uyari:  { label: "Uyarı",  renk: "sun",   sira: 2 },
  bilgi:  { label: "Bilgi",  renk: "sky",   sira: 1 },
};

export const SABLONLAR = {
  nazik:
    "Sayın {veli}, {ogrenci} için {donem} dönemi ödemesinin son günü {vade}. " +
    "Tutar: {tutar}. Bilginize, {kurum}.",

  vade:
    "Sayın {veli}, {ogrenci} için {donem} dönemi ödemesinin vadesi geçti. " +
    "Açık tutar: {tutar}. Ödemenizi tamamladıysanız bu mesajı dikkate almayınız. {kurum}",

  ikinci:
    "Sayın {veli}, {ogrenci} için {donem} dönemi ödemesi hâlâ görünmüyor. " +
    "Açık tutar: {tutar}. Ödeme güçlüğü yaşıyorsanız taksitlendirme " +
    "görüşebiliriz — lütfen bizi arayın. {kurum}",

  yonetim:
    "Sayın {veli}, {ogrenci} için {donem} dönemi ödemesi 15 günü aştı. " +
    "Açık tutar: {tutar}. Konuyu görüşmek için en kısa sürede kurum " +
    "yönetimiyle iletişime geçmenizi rica ederiz. {kurum}",
};

export const BELGE_TURU = {
  "İlk Yardım": { gecerlilikYil: 3, zorunlu: true, veren: "Kızılay" },
  "Hijyen Belgesi": { gecerlilikYil: 3, zorunlu: true, veren: "Sağlık Bakanlığı" },
  "Gıda Güvenliği": { gecerlilikYil: 5, zorunlu: true, veren: "Sağlık Bakanlığı" },
  "SRC Belgesi": { gecerlilikYil: 5, zorunlu: true, veren: "Ulaştırma Dairesi" },
  "Sağlık Raporu": { gecerlilikYil: 1, zorunlu: true, veren: "Devlet Hastanesi" },
  "Sabıka Kaydı": { gecerlilikYil: 1, zorunlu: true, veren: "Mahkeme" },

  // Süresiz — bir kez alınır, yenilenmez.
  "Montessori Eğitmenliği": { gecerlilikYil: null, zorunlu: false },
  "Çocuk Gelişimi Semineri": { gecerlilikYil: null, zorunlu: false },
  "Oyun Terapisi": { gecerlilikYil: null, zorunlu: false },
  "Çocuk Değerlendirme Ölçekleri": { gecerlilikYil: null, zorunlu: false },
  "İlkokula Hazırlık Programı": { gecerlilikYil: null, zorunlu: false },
};

/** Tanımsız belge türü için varsayılan — süresiz, zorunlu değil. */
export const VARSAYILAN_TUR = { gecerlilikYil: null, zorunlu: false, veren: null };
